import { Color, DSTokenMap, Font, FontSize, FontWeight } from '@rover/kibble/styles';
import Enum from '@rover/types/src/Enum';

export default class CalloutBadgeStyle extends Enum<{
  'background-color': Color;
  height: number;
  'border-radius': string;
  'border-width': string;
  'border-style': string;
  'border-color': Color | string;
  color: Color;
  'font-size': FontSize | string;
  'font-weight': FontWeight;
  'line-height': string;
  padding: string;
}> {
  static DEFAULT = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 20,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '2px 8px',
  });

  static NEW = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 20,
    'border-radius': '2px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '2px 8px',
  });

  static HIGHEST_EARNERS = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 20,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '2px 8px',
  });

  static AWAY = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 20,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '2px 8px',
  });

  static NEW_AWAY = new CalloutBadgeStyle({
    'background-color': DSTokenMap.BACKGROUND_COLOR_CONTRAST,
    height: 24,
    'border-radius': '4px',
    'border-color': DSTokenMap.BACKGROUND_COLOR_CONTRAST,
    'border-width': '0px',
    'border-style': 'solid',
    color: DSTokenMap.TEXT_COLOR_PRIMARY_INVERSE,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.HEAVY,
    'line-height': 'initial',
    padding: '4px 8px',
  });

  static HIGHLIGHTED_FEATURE = new CalloutBadgeStyle({
    'background-color': DSTokenMap.BACKGROUND_COLOR_TERTIARY,
    height: 24,
    'border-radius': '4px',
    'border-color': DSTokenMap.BACKGROUND_COLOR_TERTIARY,
    'border-width': '1px',
    'border-style': 'solid',
    color: DSTokenMap.TEXT_COLOR_SECONDARY,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '2px 4px',
  });

  static REPEAT_CLIENTS = new CalloutBadgeStyle({
    'background-color': DSTokenMap.BACKGROUND_COLOR_TERTIARY,
    height: 24,
    'border-radius': '4px',
    'border-color': DSTokenMap.BORDER_COLOR_HIGHLIGHT,
    'border-width': '0px',
    'border-style': 'solid',
    color: DSTokenMap.TEXT_COLOR_TERTIARY,
    'font-size': Font.FontSize.S,
    'font-weight': Font.FontWeight.NORMAL,
    'line-height': '1.6',
    padding: '4px 12px',
  });

  static STAR_SITTER = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 27,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 6px',
  });

  static STAR_SITTER_SMALL = new CalloutBadgeStyle({
    'background-color': Color.YELLOW_400,
    height: 27,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.YELLOW_900,
    'font-size': '13px',
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 6px',
  });

  static NEW_TO_ROVER = new CalloutBadgeStyle({
    'background-color': Color.BLUE_200,
    height: 27,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_900,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 6px',
  });

  static NEW_TO_ROVER_SMALL = new CalloutBadgeStyle({
    'background-color': Color.BLUE_200,
    height: 27,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_900,
    'font-size': '13px',
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 6px',
  });

  static COMING_SOON = new CalloutBadgeStyle({
    'background-color': Color.NEUTRAL_800,
    height: 27,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_WHITE,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 6px',
  });

  static BEHAVIORAL_SIGNALS = new CalloutBadgeStyle({
    'background-color': Color.BLUE_100,
    height: 26,
    'border-radius': '4px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.BLUE_600,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '1.6',
    padding: '4px 8px',
  });

  static BACKGROUND_FEE_DISCOUNT = new CalloutBadgeStyle({
    'background-color': Color.BLUE_400,
    height: 26,
    'border-radius': '10px',
    'border-color': 'transparent',
    'border-width': '0px',
    'border-style': 'none',
    color: Color.NEUTRAL_WHITE,
    'font-size': Font.FontSize.M,
    'font-weight': Font.FontWeight.BOLD,
    'line-height': '125%',
    padding: '4px 8px',
  });

  static isLocked = true;

  toString(): string {
    return `
      background-color: ${this.value['background-color'].toString()};
      height:${this.value.height.toString()}px;
      border-radius: ${this.value['border-radius'].toString()};
      border-color: ${this.value['border-color'].toString()};
      border-width: ${this.value['border-width'].toString()};
      border-style: ${this.value['border-style'].toString()};
      color: ${this.value.color.toString()};
      font-size: ${this.value['font-size'].toString()};
      font-weight: ${this.value['font-weight'].toString()};
      line-height: ${this.value['line-height'].toString()};
      padding: ${this.value.padding.toString()};
    `;
  }
}
